import React, { useEffect, useState } from "react";
import { CrudModal } from "../../components/_index";
import { Formik, Form, Field } from "formik";
import Grid from "@mui/material/Grid2";
import { Typography, Button, Box } from "@mui/material";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { AutoComplete, DatePicker } from "../../components/_index";
import { showToast } from "../../redux/Reducer/toastReducer";
import {
  getCategory,
  getRole,
  postCategory,
  updateCategory,
} from "../../services/category.service";
import { getSpecificUser } from "../../services/user.service";

const AddCategory = ({
  handleCloseDrawer,
  formType,
  selectedData,
  setOpenDrawer,
  GetCategoryData,
}) => {
  const dispatch = useDispatch();
  const disabled = formType === "view";
  const [categoryData, setCategoryData] = useState([]);
  const [userData, setUserData] = useState([]);
  const [department, setDepartment] = useState([]);

  console.log("departmenttt", department);

  const [initialValues, setInitialValues] = useState({
    name: "",
    description: "",
    roleId: "",
  });

  const validationSchema = yup.object().shape({
    name: yup.string().required("Category Name Required *"),
    roleId: yup.string().required("Department is required *"),
  });

  useEffect(() => {
    if (formType === "edit" || formType === "view") {
      setInitialValues({
        name: selectedData.name || "",
        description: selectedData.description || "",
        roleId: selectedData?.roleId || "", // <-- Added
      });
    }
  }, [formType, selectedData]);

  const onSubmit = async (values) => {
    try {
      const apiMethod =
        formType === "edit"
          ? updateCategory(selectedData._id, values)
          : postCategory(values);
      const res = await apiMethod;
      setOpenDrawer(false);
      GetCategoryData();
      dispatch(showToast({ message: res.message, type: "success" }));
    } catch (error) {
      dispatch(showToast({ message: error.data.message, type: "error" }));
    }
  };

  const GetCategoryDatas = async () => {
    try {
      const res = await getRole();
      console.log(res, "CR");
      const modifiedData =
        res?.data
          .filter(
            (e) =>
              e.name === "HR" ||
              e.name === "PROJECT MANAGER" ||
              e.name === "FEEDBACK-ADMIN" ||
              e.name === "IT SUPPORT"
          )
          .map((e) => ({
            ...e,
            label: e.name,
            id: e._id,
          })) || [];
      setDepartment(modifiedData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    GetCategoryDatas();
  }, []);

  return (
    <CrudModal
      title={
        formType === "add"
          ? "Add Category"
          : formType === "edit"
          ? "Edit Category"
          : "View Category"
      }
      open={true}
      handleClose={handleCloseDrawer}
      maxWidth="xs">
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema}>
        {({ touched, errors, setFieldValue, values }) => (
          <div className="formContainer" style={{ height: "fit-content" }}>
            <Form>
              <Grid container spacing={2}>
                <Grid size={{ xs: 12, sm: 12 }}>
                  <Typography className="inputTitle" sx={{ fontSize: "12px" }}>
                    Category Name
                  </Typography>
                  <Field
                    name="name"
                    className="InputField"
                    placeholder="Enter Category Name"
                    disabled={disabled}
                  />
                  <div className="form-error">
                    {touched.name && errors.name ? errors.name : null}
                  </div>
                </Grid>
                <Grid size={{ xs: 12, sm: 12 }}>
                  <Typography className="inputTitle" sx={{ fontSize: "12px" }}>
                    Description
                  </Typography>
                  <Field
                    name="description"
                    className="InputField"
                    placeholder="Enter Description"
                    disabled={disabled}
                  />
                  <div className="form-error">
                    {touched.description && errors.description
                      ? errors.description
                      : null}
                  </div>
                </Grid>
                <Grid size={{ xs: 12, sm: 12 }}>
                  <Typography className="inputTitle" sx={{ fontSize: "12px" }}>
                    Department
                  </Typography>
                  <AutoComplete
                    options={department}
                    value={values?.roleId}
                    getOptionLabel={(option) => option.label}
                    onChange={(e, v) => {
                      setFieldValue("roleId", v?._id || "");
                    }}
                    placeholder="Select Department to assign"
                  />
                  <div className="form-error">
                    {touched.roleId && errors.roleId ? errors.roleId : null}
                  </div>
                </Grid>
                <Grid size={{ xs: 12 }} mt={2}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: "20px",
                    }}>
                    <Button
                      className="cancelButton"
                      onClick={() => setOpenDrawer(false)}>
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      className="addButton"
                      sx={{ display: formType === "view" ? "none" : "flex" }}>
                      {formType === "edit" ? "Update" : "Save"}
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Form>
          </div>
        )}
      </Formik>
    </CrudModal>
  );
};

export default AddCategory;
